module.exports = __webpack_public_path__ + "img/icon-language-title.f1590d06.png";